import React, { useState } from 'react';
import { WtUi } from 'wt-ui';
import { useTranslation } from 'react-i18next';
import ErrorBoundary from '../../components/ErrorBoundary';
import Content from '../Content';
import Content2 from '../Content2';

import newrelic from './newrelic';
import hotjar from './hotjar';
import heap from './heap';

// we need to initialize our i18n module
// eslint-disable-next-line no-unused-vars
import i18n from '../../translations/i18n';

newrelic.init();
hotjar.init();
heap.init();
heap.track('LoadHeatmap');

const contentMap = {
  0: <Content />,
  2: <Content2 />,
};

const App = () => {
  // eslint-disable-next-line
  const [content, setContent] = useState(0);

  const { i18n: _i18n } = useTranslation();
  const siteCoreLang = (window.slHeatmap && window.slHeatmap.isoCode) || 'en-GB';
  _i18n.changeLanguage(siteCoreLang);

  const contentToRender = contentMap[content];
  return (
    <WtUi>
      <div id="app_version" style={{ display: 'none' }}>
        {process.env.REACT_APP_VERSION}
      </div>
      <div id="commit_hash" style={{ display: 'none' }}>
        {process.env.REACT_APP_COMMIT_HASH}
      </div>
      <ErrorBoundary>{contentToRender}</ErrorBoundary>
    </WtUi>
  );
};

export default App;
